module.exports = __webpack_public_path__ + "img/icon_change_device.8df37eb8.svg";